export class GetPfiListByOrgRequestModel{
    role:string;
}